import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-popup.mjs";
import { render } from "lit-html";
import { isRunningAsPWA, isProduction } from "../../global.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

export class HbPopup extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private modal: ModalInterface;
    private opener: Window | null = null;

    private popup: HTMLElement;
    private iframe: HTMLIFrameElement;
    private btn: HTMLElement;

    allowedOpenerPattern = isProduction
        ? /\.(heartbank|thonly|siliconwat|333)\./i
        : /(localhost|127\.0\.0\.1):\d+/i;

    constructor() {
        super();
        render(template(null), this);

        this.popup = this.querySelector("#hb-popup")!;
        this.iframe = this.querySelector("#hb-popup-iframe")!;
        this.btn = this.querySelector("#hb-popup-btn")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-popup",
            override: true
        };

        this.modal = new Modal(this.popup, modalOptions, instanceOptions);
    }

    connectedCallback() {
        //this.sendMessageToOpener({ action: "status", message: "Hello! 2" });
        window.addEventListener("message", (event: MessageEvent) => {
            if (this.allowedOpenerPattern.test(event.origin))
                this.handleMessageFromOpener(event.data);
        });
    }

    private show(src: string) {
        this.iframe.src = src;
        this.modal.show();
    }

    private hide() {
        this.modal.hide();
    }

    openHB(extension: string, endpoint: string) {
        const url = `https://heartbank.${extension}/?lang=en&origin=${
            isRunningAsPWA ? "pwa" : "web"
        }#/${endpoint}`;
        this.opener = window.open(url, "HeartBank®", "width=500,height=500");
        if (!this.opener) this.show(url); //alert("Please allow popup for the best experience of HeartBank®");
    }

    openThank(extension: string, endpoint: string) {
        const domain =
            extension === "eco" ? "333.eco" : "heartbank." + extension;
        const url = `https://thank.${domain}/?lang=en&origin=${
            isRunningAsPWA ? "pwa" : "web"
        }#/${endpoint}`;
        this.opener = window.open(url, "HeartBank®", "width=500,height=500");
        if (!this.opener) this.show(url); //alert("Please allow popup to open HeartBank®");
    }

    private handleMessageFromOpener(data: {
        action: string;
        [key: string]: any;
    }): void {
        switch (data.action) {
            case "status":
                console.log(data.message);
                break;
            default:
            //console.log("Unknown action: ", data);
        }
    }

    private sendMessageToOpener(data: {
        action: string;
        [key: string]: any;
    }): void {
        this.opener?.postMessage(data, "*");
    }
}
